// Used a separate file for bundling
export function isTextStylePanelSupported(
	zone: eXpress.core.IZone | undefined,
	definition: eXpress.core.IDefinition | null | undefined,
	dashboard: eXpress.TextZoneDashboard,
) {
	if (zone) {
		return (
			dashboard.canSetTextBold(zone) ||
			dashboard.canSetTextItalic(zone) ||
			dashboard.canSetTextUnderline(zone)
		);
	}
	if (!definition) return false;

	return definition
		.textZones()
		.some(
			(textZone) =>
				dashboard.canSetTextBold(textZone) ||
				dashboard.canSetTextItalic(textZone) ||
				dashboard.canSetTextUnderline(textZone),
		);
}
